import { render, staticRenderFns } from "./vt-loading-button-spinner.vue?vue&type=template&id=272133f4&scoped=true&"
import script from "./vt-loading-button-spinner.ts?vue&type=script&lang=ts&"
export * from "./vt-loading-button-spinner.ts?vue&type=script&lang=ts&"
import style0 from "./vt-loading-button-spinner.scss?vue&type=style&index=0&id=272133f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272133f4",
  null
  
)

export default component.exports